import React from 'react';
import './Notifications.css';

const Notifications = () => {
    return (
        <div className="page-container">
            <div className="placeholder-content">
                <h2>Notifications</h2>
                <p>Notifications center coming soon...</p>
            </div>
        </div>
    );
};

export default Notifications;
